import { render, staticRenderFns } from "./edit-producer-company.vue?vue&type=template&id=aaf3ac62&"
import script from "./edit-producer-company.vue?vue&type=script&lang=js&"
export * from "./edit-producer-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports